import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { ExportTicketTypesRequest } = protos;

export function downloadTicketTypeExport(businessId: number, ticketTypeIds: number[]): ApiAction {
  return {
    TockApi: {
      postProtoForFile: '/ticket/type/menu-export',
      request: ExportTicketTypesRequest.fromObject({ ticketTypeId: ticketTypeIds }),
      type: ClowncarAppConstants.MENU_MIGRATOR_EXPORT,
      scope: {
        businessId,
      },
    },
  };
}

export function importFile(businessId: number, file: File): ApiAction {
  return {
    TockApi: {
      postFile: `/menu/import`,
      type: ClowncarAppConstants.MENU_MIGRATOR_IMPORT,
      request: file,
      toast: 'Menus successfully imported',
      scope: {
        businessId,
      },
    },
  };
}
